import { registerModal } from "@/shared/lib/modal/modal-registry";
import AlertDetailModal from "./alert-detail-modal";
import TimelineTrackSettingsModal from "./timeline-track-settings-modal";
import ErrorDetailModal from "./error-detail-modal";
import MachineTargetsModal from "./machine-targets-modal";
import AddCameraAngleModal from "./add-camera-angle-modal";

registerModal("alert-detail", AlertDetailModal, {
  maxWidth: 1400,
});

registerModal("timeline-track-settings", TimelineTrackSettingsModal, {
  titleKey: "machines:trackSettings.title",
  maxWidth: 600,
});

registerModal("error-detail", ErrorDetailModal, {
  titleKey: "machines:errorDetail.title",
  maxWidth: 800,
});

registerModal("machine-targets", MachineTargetsModal, {
  titleKey: "machines:targetsModal.title",
  maxWidth: 480,
});

registerModal("add-camera-angle", AddCameraAngleModal, {
  titleKey: "machines:cameraAngleModal.title",
  maxWidth: 450,
});
